import { createSlice } from "@reduxjs/toolkit";
import { fetchPendingSalesOrderReturn } from "./thunk";

interface PendingSalesOrderReturnState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PendingSalesOrderReturnState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const PendingSalesOrderReturnSlice = createSlice({
  name: "PendingSalesOrderReturn",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPendingSalesOrderReturn.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPendingSalesOrderReturn.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchPendingSalesOrderReturn.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Pending Sales Order Returns";
      });
  },
});

export default PendingSalesOrderReturnSlice.reducer;